import * as React from 'react';

import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as DocumentsStore from '@store/documents';
import { WorkDocuments } from '@components/work/WorkDocuments';

export default connect(
    (state: ApplicationState) => ({
        ...state.identity,
        ...state.user,
        ...DocumentsStore.plainActions,
        work: state.user.work,
    }),
    {}
)(WorkDocuments as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
